<template>
  <div data-cursor>
    <div class="cur1">
      <span class="see">See</span>
    </div>
    <div class="cur2"></div>
  </div>
</template>

<script>
import $ from "jquery";
import gsap from "gsap-3";

var $g = gsap;

export default {
  name: "AppCursor",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //see https://www.point-web.fr/
      var $cursor = {
        cur: $("[data-cursor]"),
        cur1: $("[data-cursor] .cur1"),
        cur2: $("[data-cursor] .cur2"),
        classCursor: function() {
          var t = this;
          $("[data-cc]").each(function() {
            var $t = $(this);
            var c = $t.data("cc");
            $t.on({
              mouseover: function() {
                $("body").addClass(c);
              },
              mouseleave: function() {
                $("body").removeClass(c);
              },
            });
          });
        },
        init: function() {
          var t = this;
          t.classCursor();
          $(document).on({
            mousemove: function(e) {
              var cx = e.pageX;
              var cy = e.pageY;
              $g.to(t.cur1, 0, { left: cx, top: cy });
              $g.to(t.cur2, 0.15, { left: cx, top: cy });
            },
          });
          $(
            ".line-ec .lp > *, form fieldset, form label, input, textarea, a, button, [data-nav], [data-link], [data-hover], [data-mail], [data-part]"
          ).each(function() {
            $(this).on({
              mouseenter: function() {
                $("body").addClass("hover");
              },
              mouseleave: function() {
                $("body").removeClass("hover");
              },
            });
          });
        },
      };

      $cursor.init();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

[data-cursor] {
  mix-blend-mode: difference;
  display: none;
  pointer-events: none;
  width: 0;
  height: 0;
  margin-top: 2px;
  margin-left: 2px;
  z-index: 99999999;
  position: absolute;
  top: 0;
  left: 0;
}

.eth [data-cursor] {
  mix-blend-mode: normal;
}

html {
  &:hover [data-cursor] {
    display: block;
  }

  &.ie [data-cursor],
  &.mob [data-cursor] {
    display: none !important;
  }
}

[data-cursor] .cur1 {
  position: relative;
  width: 5px;
  height: 5px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  z-index: 5;

  > * {
    opacity: 0;
    transition: 0.4s;
    font-weight: 800;
    font-size: 14px;
    color: #edf1f3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    text-align: center;
  }
}

.eth [data-cursor] .cur1 > .see {
  opacity: 1;
}

[data-cursor] .cur2 {
  position: relative;
  transition: opacity 0.4s, transform 0.4s;
  opacity: 0.3;
  width: 15px;
  height: 15px;
  // background-color: #edf1f3;
  background-color: $b1;
  margin: -11px 0 0 -10px;
  border-radius: 50%;
}

.hover [data-cursor] .cur2,
.drag [data-cursor] .cur2 {
  transform: scale(4);
  opacity: 0.1;
}

.eth [data-cursor] .cur2 {
  background-color: #000;
  opacity: 1;
  transform: scale(4);
}

body.eth * {
  cursor: none !important;
}
</style>
